import React from 'react';
import { BookOpen } from 'lucide-react';
type ModuleItem = {
  module: string;
  transformation: string;
};
const modules: ModuleItem[] = [{
  module: 'Capítulo 1: Descubre que sí puedes crear un PDF',
  transformation: 'Empiezas con seguridad y claridad'
}, {
  module: 'Capítulo 2: Mentalidad de Emprendedora Digital',
  transformation: 'Sueltas bloqueos y miedos'
}, {
  module: 'Capítulo 3: Encuentra una idea con demanda',
  transformation: 'Eliges una propuesta con potencial'
}, {
  module: 'Capítulo 4: Estructura tu PDF sin complicaciones',
  transformation: 'Tu idea se convierte en algo listo para vender'
}, {
  module: 'Capítulo 5: Crea tu PDF con Gamma fácilmente',
  transformation: 'Tienes un producto terminado y profesional'
}, {
  module: 'Bonus: Plan 7 días para mujeres ocupadas',
  transformation: 'Sabes exactamente qué hacer cada día'
}];
export function ModulesSection() {
  return <section className="py-8 px-4 bg-white" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        {/* Header */}
        <div className="text-center mb-5" data-id="element-134">
          <h2 className="text-[22px] font-bold text-[#222222] mb-2" data-id="element-135">
            ¿Qué incluye Mujer Digital 3.0?
          </h2>
          <p className="text-[14px] md:text-[16px] text-[#666666] max-w-[80%] mx-auto leading-relaxed" data-id="element-136">
            Imagina esto como tu mapa + tu método + tus herramientas listas para
            lanzar tu primer producto digital.
          </p>
        </div>

        {/* Image Placeholder */}
        <div className="flex justify-center mb-5" data-id="element-137">
          <img src="https://cdn.magicpatterns.com/uploads/tQyTuBgXd9X9HSqA4yeQBf/ChatGPT_Image_5_feb_2026,_16_38_42.png" alt="Mujer Digital 3.0 - Contenido del curso y bonos" className="w-full max-w-[280px] rounded-2xl shadow-2xl" data-id="element-138" />
        </div>

        {/* Card Container for Table */}
        <div className="my-6 bg-white rounded-2xl p-4 md:p-5 border border-[#F0F0F0] transition-shadow duration-300" style={{
        boxShadow: '0 12px 24px rgba(0, 0, 0, 0.08)'
      }} data-id="element-139">
          {/* 2-Column Comparison Table */}
          <table className="w-full border-collapse text-[12px] md:text-[14px]" data-id="element-140">
            {/* Table Header */}
            <thead data-id="element-141">
              <tr className="border-b-2 border-gray-100" data-id="element-142">
                <th className="py-2 px-2 md:px-4 text-left font-bold text-gray-500 uppercase tracking-wide w-[55%]" data-id="element-143">
                  Módulo
                </th>
                <th className="py-2 px-2 md:px-4 text-left font-bold text-gray-500 uppercase tracking-wide w-[45%]" data-id="element-144">
                  Transformación
                </th>
              </tr>
            </thead>
            {/* Table Body */}
            <tbody data-id="element-145">
              {modules.map((item, index) => <tr key={index} className={`${index % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`} data-id="element-146">
                  <td className="py-2.5 px-2 md:px-4 font-semibold text-[#222222] leading-snug align-top" data-id="element-147">
                    {item.module}
                  </td>
                  <td className="py-2.5 px-2 md:px-4 font-semibold text-[#FF4DA6] leading-snug align-top" data-id="element-148">
                    {item.transformation}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}